export default "__VITE_ASSET__D2kVG5p$__"